import type { AxelorRecordId } from '@core/http/axelor/contracts/axelor-common.types';

function encodePathSegment(value: string | number): string {
  return encodeURIComponent(String(value));
}

export function buildAxelorWsAppInfoPath(): string {
  return 'ws/app/info';
}

export function buildAxelorCallbackPath(): string {
  return 'callback';
}

export function buildAxelorLogoutPath(): string {
  return 'logout';
}

export function buildAxelorMetaModelsPath(): string {
  return 'ws/meta/models';
}

export function buildAxelorMetaFieldsPath(model: string): string {
  return `ws/meta/fields/${encodePathSegment(model)}`;
}

export function buildAxelorRestCollectionPath(model: string): string {
  return `ws/rest/${encodePathSegment(model)}`;
}

export function buildAxelorRestItemPath(model: string, id: AxelorRecordId): string {
  return `${buildAxelorRestCollectionPath(model)}/${encodePathSegment(id)}`;
}

export function buildAxelorRestFetchPath(model: string, id: AxelorRecordId): string {
  return `${buildAxelorRestItemPath(model, id)}/fetch`;
}

export function buildAxelorRestRemoveAllPath(model: string): string {
  return `${buildAxelorRestCollectionPath(model)}/removeAll`;
}

export function buildAxelorRestSearchPath(model: string): string {
  return `${buildAxelorRestCollectionPath(model)}/search`;
}

export function buildAxelorActionPath(): string {
  return 'ws/action';
}

/** Все пункты меню Axelor (плоский список с `parent`). */
export function buildAxelorMenuAllPath(): string {
  return 'ws/action/menu/all';
}

export function buildAxelorDmsFilesPath(): string {
  return 'ws/dms/files';
}

export function buildAxelorDmsDownloadPath(id: AxelorRecordId): string {
  return `ws/dms/download/${encodePathSegment(id)}`;
}

export function buildAxelorFilesUploadPath(): string {
  return 'ws/files/upload';
}

export function buildAxelorDmsAttachmentsPath(model: string, id: AxelorRecordId): string {
  return `ws/dms/attachments/${encodePathSegment(model)}/${encodePathSegment(id)}`;
}
